import type { HttpMock } from '#e2e-utils/mockScenarios';

export const errorGetIterationMocks: HttpMock[] = [
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId$',
    },
    response: {
      status: 500,
      body: {},
    },
  },
];
